import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'app/store/store'
import { IHospitals, IProgramCaseState, TError } from './types/program-case-interface'

const ProgramCaseState = (state: RootState): IProgramCaseState => state.programCase

export const СaseProgram = createSelector(
    [ProgramCaseState],
    (state): IHospitals[] => state.caseProgram,
)
export const HospitalCount = createSelector(
    [ProgramCaseState],
    (state): number => state.HospitalCount,
)
export const LoadingCaseProgram = createSelector(
    [ProgramCaseState],
    (state): boolean => state.isLoadingCaseProgram,
)
export const ErrorCaseProgram = createSelector(
    [ProgramCaseState],
    (state): TError => state.errorCaseProgram,
)

export const LastFetchCaseProgram = createSelector(
    [ProgramCaseState],
    (state): null | number => state.lastFetchTime,
)

export const PrintNameCaseProgram = createSelector(
    [ProgramCaseState],
    (state): string => state.PrintName,
)

export const ProgramID = createSelector(
    [ProgramCaseState],
    (state): string => state.programID,
)

export const CurrentPageProgram = createSelector(
    [ProgramCaseState],
    (state): number => state.currentPage,
)


export const Download = createSelector(
    [ProgramCaseState],
    (state): boolean => state.isDownload,
)
export const ErrorDownload = createSelector(
    [ProgramCaseState],
    (state): TError => state.errorDownload,
)
export const FileData = createSelector(
    [ProgramCaseState],
    (state): string => state.FileData,
)
export const FileName = createSelector(
    [ProgramCaseState],
    (state): string => state.FileName,
)